import React, { Suspense } from 'react';
import { useSpring, animated } from 'react-spring';
import { Box } from '@mui/material';
import styled from 'styled-components';
import {
  useAppSelector,
  getFeedbackPanelState,
  getDevice,
} from '@breakroom-nx/redux';
import { theme } from '@breakroom-nx/assets';

// Lazy load FeedbackContainer
const LazyFeedbackContainer = React.lazy(() =>
  import('@breakroom-nx/ui').then((mod) => ({ default: mod.FeedbackContainer }))
);

// Styled Components
const Pane = styled(Box)<{ $mobileDevice?: boolean }>`
  height: 60vh;
  position: fixed;
  top: 50%;
  left: -2vw;
  padding-left: 2vw;
  background: ${theme.colors.surface[100]};
  border: 1px solid ${theme.colors.surface[200]};
  border-radius: 0px 25px 25px 0px;
  box-shadow: rgba(0, 0, 0, 0.25) -25px 0px 40px -12px;
`;

function FeedbackWrapper() {
  const mobileDevice = useAppSelector(getDevice);

  const AnimatedFeedbackPanePane = animated(Pane);

  // Panel Controls
  const paneDisplayed = useAppSelector(getFeedbackPanelState);

  // React Spring Animations
  const { transformPane, paneOpacity } = useSpring({
    paneOpacity: 1,
    transformPane: `translateY(-50%) translateX(${paneDisplayed ? 0 : -100}vw)`,
    config: { mass: 5, tension: 500, friction: 80 },
  });

  return (
    <AnimatedFeedbackPanePane
      width={{
        xs: '90vw',
        sm: '60vw',
        md: '40vw',
        lg: '40vw',
        xl: '20vw',
      }}
      style={{
        opacity: paneOpacity,
        transform: transformPane,
        overflow: 'hidden',
        display: 'flex',
        zIndex: 2,
      }}
      $mobileDevice={mobileDevice}
    >
      {paneDisplayed && (
        <Suspense fallback={null}>
          <LazyFeedbackContainer />
        </Suspense>
      )}
    </AnimatedFeedbackPanePane>
  );
}

export default React.memo(FeedbackWrapper);
